import { createFileRoute } from "@tanstack/react-router";
import { customerStateWidgetQueryOptions } from "@/features-root-user/service/dashboard";
import { queryClient } from "@/main";
import Leads from "@/features-root-user/leads/leads";

export const Route = createFileRoute("/_root/root-user/customer/leads")({
  component: Leads,
  loader: async () => {
    queryClient.ensureQueryData(customerStateWidgetQueryOptions);
  },
});
